<div [formGroup]="form">
  @if (passwordChange) {
    <mat-form-field>
      <mat-label i18n>Altes Passwort</mat-label>
      <input matInput [type]="hidePassword ? 'password' : 'test'" formControlName="oldPassword" required />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hidePassword"
        tabindex="-1"
      >
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      @if (form.hasError('required', 'oldPassword')) {
        <mat-error i18n>Bitte gib Dein altes Passwort an</mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field i18n-hintLabel hintLabel="Mindestens 8 Zeichen">
    <mat-label>
      @if (newPassword) {
        <ng-container i18n>Neues Passwort</ng-container>
      } @else {
        <ng-container i18n>Passwort</ng-container>
      }
    </mat-label>

    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" required />
    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
      tabindex="-1"
    >
      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    @if (form.hasError('required', 'password')) {
      <mat-error i18n>Bitte gib ein Passwort an</mat-error>
    }
    @if (form.hasError('minlength', 'password')) {
      <mat-error i18n>Das Passwort muss mindestens 8 Zeichen lang sein</mat-error>
    }
  </mat-form-field>
  <dt-passwordstrength [password]="form.get('password').value" (passwordValid)="passwordValid = $event"></dt-passwordstrength>

  <mat-form-field>
    <mat-label>
      @if (newPassword) {
        <ng-container i18n>Neues Passwort wiederholen</ng-container>
      } @else {
        <ng-container i18n>Passwort wiederholen</ng-container>
      }
    </mat-label>
    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="passwordRepeat" required />
    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
      tabindex="-1"
    >
      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>

    @if (form.hasError('required', 'passwordRepeat')) {
      <mat-error i18n>Bitte wiederhole Dein Passwort</mat-error>
    }
    @if (form.hasError('matchOther', 'passwordRepeat')) {
      <mat-error i18n>Die Passwörter stimmen nicht überein</mat-error>
    }
  </mat-form-field>
</div>
